import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Injectable()
export class JackpotService {
  public _info: any | null = null;
  private _infoSubject: Subject<any | null> = new BehaviorSubject(null);
  info$: Observable<any | null> = this._infoSubject.asObservable();

  public _jackpotInfo: any | null = null;
  private _jackpotInfoSubject: Subject<any | null> = new BehaviorSubject(null);
  jackpotInfo$: Observable<any | null> = this._jackpotInfoSubject.asObservable();

  constructor(private http: Http, private auth: AuthenticationService) {
    this.getInfo().then((data: any) => {
      auth.userInfo$.subscribe((user: any) => {
        if (user) {
          this.getAuthInfo();
        } else {
          this._info = null;
          this._infoSubject.next(this._info);
        }
      });
    });
  }

  getAuthInfo() {
    if (!this.auth.credentials) {
      // Why error?
      // this._userInfoSubject.error(UserInfoError.NO_CREDENTIALS);
      return Promise.resolve(null);
    }
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http
      .get('/api/jackpot/player', { headers: headers })
      .toPromise()
      .then((data: any) => {
        this._info = data.json();
        this._infoSubject.next(this._info);
        return data.json();
      });
  }

  openChest() {
    if (!this.auth.credentials) {
      // Why error?
      // this._userInfoSubject.error(UserInfoError.NO_CREDENTIALS);
      return Promise.resolve(null);
    }
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http
      .post('/api/jackpot/open-chest', {}, { headers: headers })
      .toPromise()
      .then((data: any) => {
        return data.json();
      });
  }

  getInfo() {
    return this.http
      .get('/api/jackpot')
      .toPromise()
      .then(data => {
        this._jackpotInfo = data.json();
        this._jackpotInfoSubject.next(this._jackpotInfo);
        return data.json();
      })
      .catch(e => {
        this._jackpotInfo = null;
        this._jackpotInfoSubject.next(this._jackpotInfo);
      });
  }

  getKeyBySeeds(seeds: any) {
    return this.http
      .post('/api/jackpot/fairness', seeds)
      .toPromise()
      .then((data: any) => {
        return data.json();
      });
  }

  getJackpotInfo(id: string = '0') {
    return this.http
      .get('/api/jackpot/' + id + '/keys')
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  getJackpotFairness(seeds: any) {
    return this.http
      .post('/api/jackpot/' + seeds.jackpotId + '/fairness', seeds)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public getHistory(page: number = 1) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();
    params.set('page', page.toString());

    options.search = params;

    return this.http
      .get('/api/jackpot/history', options)
      .toPromise()
      .then((data: any) => {
        return data.json();
      });
  }

  public gameKeys(page: number = 1) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();
    params.set('page', page.toString());

    options.search = params;

    return this.http
      .get('/api/jackpot/keys', options)
      .toPromise()
      .then((data: any) => {
        return data.json();
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/jackpot.service.ts